import React from 'react';
import { NavLink, Redirect, Route, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import SarConfig from './SarConfig';
import SdpConfig from './SdpConfig';
import ApnsConfig from './ApnsConfig';

const Integrations: React.FC = () => {
  if (window.location.pathname === '/dashboard/integrations') {
    return <Redirect to="/dashboard/integrations/sar" />;
  }

  return (
    <div className="worldCup_header_layout">
      <div className="worldCup_config_header_wrapper">
        <div className="sar_config_list_header">
          <div className="header_title">
            <FormattedMessage id="Integrations" />
          </div>
        </div>
        <div className="menu_items">
          <nav className="menu_nav">
            <NavLink to="/dashboard/integrations/sar" activeClassName="active">
              <FormattedMessage id="SAR" />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to="/dashboard/integrations/sdp" activeClassName="active">
              <FormattedMessage id="SDP" />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to="/dashboard/integrations/apns" activeClassName="active">
              <FormattedMessage id="APNs" />
            </NavLink>
          </nav>
        </div>
      </div>
      <div className="worldCup_layout_content">
        <div className="worldCup_layout_content_box">
          <Switch>
            <Route exact path="/dashboard/integrations/sar" component={SarConfig} />
            <Route exact path="/dashboard/integrations/sdp" component={SdpConfig} />
            <Route exact path="/dashboard/integrations/apns" component={ApnsConfig} />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Integrations;
